export const formatLocationShort = (location: { city: string; state: string }) => {
  return location.city ? `${location.city}, ${location.state}` : location.state;
};

export const formatLocationLong = (location: { city: string; state: string; zipCode: string }) => {
  return location.city
    ? `${location.city}, ${location.state} ${location.zipCode}`
    : `${location.state} ${location.zipCode}`;
};
